<app-search></app-search>
<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      <h1 class="title">Lista de {{ termKey.profilesPlural | term }}</h1>
    </div>
    <br />
    <div class="card-header">
      <button id="" class="primary-button" appPermision="/profile+c" (click)="createProfile()">
        <span class="button-content"> <mat-icon>add_circle</mat-icon> Agregar nuevo </span>
      </button>
    </div>
    <br />
    <div class="table-scroll-wrapper">
      <section class="table-container mat-elevation-z1" tabindex="0">
        <div class="table-adjustable">
          <table
            mat-table
            [dataSource]="
              (asyncProfile | async)?.results ?? []
                | paginate
                  : {
                      id: 'server',
                      itemsPerPage: limit,
                      currentPage: page,
                      totalItems: total,
                    }
            "
          >
            <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let profile">
                <a mat-icon-a [matMenuTriggerFor]="menu" aria-label="Acciones" title="Acciones">
                  <mat-icon class="main-icon">menu</mat-icon>
                </a>
                <mat-menu #menu="matMenu" class="icon-menu">
                  <!-- Editar -->
                  <button
                    class="icon-button"
                    mat-menu-item
                    appPermision="/profile+u"
                    (click)="editar(profile)"
                  >
                    <span class="text-span"
                      ><mat-icon class="icon-size">edit</mat-icon>Editar
                      {{ termKey.profilesSingular | term }}</span
                    >
                  </button>
                  <button
                    class="icon-button"
                    mat-menu-item
                    (click)="updatePassword(profile)"
                    appOnlysuperuser="/profile"
                  >
                    <span class="text-span"
                      ><mat-icon class="icon-size">lock_reset</mat-icon>Cambiar contraseña</span
                    >
                  </button>

                  <mat-divider></mat-divider>

                  <!-- Asignar -->
                  <button
                    class="icon-button"
                    mat-menu-item
                    appPermision="/profile+u"
                    (click)="openDialog(profile)"
                  >
                    <span class="text-span"
                      ><mat-icon class="icon-size">group_add</mat-icon>Asignar Grupos</span
                    >
                  </button>
                  <button
                    class="icon-button"
                    mat-menu-item
                    appPermision="/profile+u"
                    (click)="openDialog(profile, 'user')"
                  >
                    <span class="text-span"
                      ><mat-icon class="icon-size">key</mat-icon>Asignar permisos</span
                    >
                  </button>
                  <button
                    class="icon-button"
                    mat-menu-item
                    appPermision="/profile+u"
                    (click)="openDialog(profile, 'sector')"
                  >
                    <span class="text-span"
                      ><mat-icon class="icon-size">domain</mat-icon>Asignar
                      {{ termKey.SectorSingular | term }}</span
                    >
                  </button>

                  <mat-divider></mat-divider>

                  <!-- Revocar -->
                  <button
                    class="icon-button"
                    mat-menu-item
                    appPermision="/profile+u"
                    (click)="onRevokePermisions(profile)"
                  >
                    <span class="text-span"
                      ><mat-icon class="icon-size">do_not_disturb_on</mat-icon>Revocar
                      permisos</span
                    >
                  </button>
                  <button
                    class="icon-button"
                    mat-menu-item
                    appPermision="/profile+u"
                    (click)="onRevokeGroups(profile)"
                  >
                    <span class="text-span"
                      ><mat-icon class="icon-size">group_remove</mat-icon>Revocar grupo</span
                    >
                  </button>

                  <mat-divider></mat-divider>

                  <!-- Eliminar -->
                  <button
                    class="icon-button"
                    mat-menu-item
                    appOnlysuperuser="/profile/:id"
                    (click)="onDelete(profile.id)"
                  >
                    <span class="text-span delete-span"
                      ><mat-icon class="icon-size delete-icon">delete</mat-icon>Eliminar
                      {{ termKey.profilesSingular | term }}</span
                    >
                  </button>
                </mat-menu>
              </td>
            </ng-container>

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef>ID</th>
              <td mat-cell *matCellDef="let profile">
                {{ profile.id }}
              </td>
            </ng-container>

            <ng-container matColumnDef="usuario">
              <th mat-header-cell *matHeaderCellDef>Usuario</th>
              <td mat-cell *matCellDef="let profile">
                {{ profile.username }}
              </td>
            </ng-container>

            <ng-container matColumnDef="nombres">
              <th mat-header-cell *matHeaderCellDef>Nombre y apellidos</th>
              <td mat-cell *matCellDef="let profile">
                {{ profile.first_name }} {{ profile.last_name }}
              </td>
            </ng-container>
            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Correo</th>
              <td mat-cell *matCellDef="let profile">
                {{ profile.email }}
              </td>
            </ng-container>

            <ng-container matColumnDef="fechaRegistro">
              <th mat-header-cell *matHeaderCellDef>Fecha de registro</th>
              <td mat-cell *matCellDef="let profile">
                {{ profile.date_joined }}
              </td>
            </ng-container>

            <ng-container matColumnDef="permisos">
              <th mat-header-cell *matHeaderCellDef>Permisos</th>
              <td mat-cell *matCellDef="let profile">({{ profile.permisions.length }})</td>
            </ng-container>

            <ng-container matColumnDef="grupos">
              <th mat-header-cell *matHeaderCellDef>Grupos</th>
              <td mat-cell *matCellDef="let profile">
                ({{ profile.role_group.length }})
                @for (item of profile.role_group; track item.id; let last = $last) {
                  {{ item.name }}
                  @if (!last) {
                    ,
                  }
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="sectores">
              <th mat-header-cell *matHeaderCellDef>{{ termKey.SectorSingular | term }}</th>
              <td mat-cell *matCellDef="let profile">
                ({{ profile.user_sector.length }})
                @for (item of profile.user_sector; track item.id; let last = $last) {
                  {{ item.sector.name }}
                  @if (!last) {
                    ,
                  }
                }
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="showColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: showColumns" class="highlight-row"></tr>
          </table>
        </div>
      </section>
    </div>
    <pagination-controls
      (pageChange)="fetchProfile($event)"
      previousLabel="Anterior"
      nextLabel="Siguiente"
      id="server"
    ></pagination-controls>
  </div>
</div>
